import { TeamInfo } from './types';

const TEAM_LOGO_BASE = 'https://awesemostorage.blob.core.windows.net/sports/mlb/teams';

export const mlbTeams: Record<string, TeamInfo> = {
  // Primary entries using standard abbreviations
  ARI: { name: 'Diamondbacks', fullName: 'Arizona Diamondbacks', abbr: 'ARI', logo: `${TEAM_LOGO_BASE}/ARID.png` },
  ATL: { name: 'Braves', fullName: 'Atlanta Braves', abbr: 'ATL', logo: `${TEAM_LOGO_BASE}/ATLB.png` },
  BAL: { name: 'Orioles', fullName: 'Baltimore Orioles', abbr: 'BAL', logo: `${TEAM_LOGO_BASE}/BALO.png` },
  BOS: { name: 'Red Sox', fullName: 'Boston Red Sox', abbr: 'BOS', logo: `${TEAM_LOGO_BASE}/BOSR.png` },
  CHC: { name: 'Cubs', fullName: 'Chicago Cubs', abbr: 'CHC', logo: `${TEAM_LOGO_BASE}/CHCC.png` },
  CWS: { name: 'White Sox', fullName: 'Chicago White Sox', abbr: 'CWS', logo: `${TEAM_LOGO_BASE}/CHWW.png` },
  CIN: { name: 'Reds', fullName: 'Cincinnati Reds', abbr: 'CIN', logo: `${TEAM_LOGO_BASE}/CINR.png` },
  CLE: { name: 'Guardians', fullName: 'Cleveland Guardians', abbr: 'CLE', logo: `${TEAM_LOGO_BASE}/CLEG.png` },
  COL: { name: 'Rockies', fullName: 'Colorado Rockies', abbr: 'COL', logo: `${TEAM_LOGO_BASE}/COLR.png` },
  DET: { name: 'Tigers', fullName: 'Detroit Tigers', abbr: 'DET', logo: `${TEAM_LOGO_BASE}/DETT.png` },
  HOU: { name: 'Astros', fullName: 'Houston Astros', abbr: 'HOU', logo: `${TEAM_LOGO_BASE}/HOUA.png` },
  KC:  { name: 'Royals', fullName: 'Kansas City Royals', abbr: 'KC', logo: `${TEAM_LOGO_BASE}/KCR.png` },
  LAA: { name: 'Angels', fullName: 'Los Angeles Angels', abbr: 'LAA', logo: `${TEAM_LOGO_BASE}/LAAA.png` },
  LAD: { name: 'Dodgers', fullName: 'Los Angeles Dodgers', abbr: 'LAD', logo: `${TEAM_LOGO_BASE}/LADD.png` },
  MIA: { name: 'Marlins', fullName: 'Miami Marlins', abbr: 'MIA', logo: `${TEAM_LOGO_BASE}/MIAM.png` },
  MIL: { name: 'Brewers', fullName: 'Milwaukee Brewers', abbr: 'MIL', logo: `${TEAM_LOGO_BASE}/MILB.png` },
  MIN: { name: 'Twins', fullName: 'Minnesota Twins', abbr: 'MIN', logo: `${TEAM_LOGO_BASE}/MINT.png` },
  NYM: { name: 'Mets', fullName: 'New York Mets', abbr: 'NYM', logo: `${TEAM_LOGO_BASE}/NYM.png` },
  NYY: { name: 'Yankees', fullName: 'New York Yankees', abbr: 'NYY', logo: `${TEAM_LOGO_BASE}/NYY.png` },
  OAK: { name: 'Athletics', fullName: 'Oakland Athletics', abbr: 'OAK', logo: `${TEAM_LOGO_BASE}/OAKA.png` },
  PHI: { name: 'Phillies', fullName: 'Philadelphia Phillies', abbr: 'PHI', logo: `${TEAM_LOGO_BASE}/PHIP.png` },
  PIT: { name: 'Pirates', fullName: 'Pittsburgh Pirates', abbr: 'PIT', logo: `${TEAM_LOGO_BASE}/PITP.png` },
  SD:  { name: 'Padres', fullName: 'San Diego Padres', abbr: 'SD', logo: `${TEAM_LOGO_BASE}/SDP.png` },
  SEA: { name: 'Mariners', fullName: 'Seattle Mariners', abbr: 'SEA', logo: `${TEAM_LOGO_BASE}/SEAM.png` },
  SF:  { name: 'Giants', fullName: 'San Francisco Giants', abbr: 'SF', logo: `${TEAM_LOGO_BASE}/SFG.png` },
  STL: { name: 'Cardinals', fullName: 'St. Louis Cardinals', abbr: 'STL', logo: `${TEAM_LOGO_BASE}/STLC.png` },
  TB:  { name: 'Rays', fullName: 'Tampa Bay Rays', abbr: 'TB', logo: `${TEAM_LOGO_BASE}/TBR.png` },
  TEX: { name: 'Rangers', fullName: 'Texas Rangers', abbr: 'TEX', logo: `${TEAM_LOGO_BASE}/TEXR.png` },
  TOR: { name: 'Blue Jays', fullName: 'Toronto Blue Jays', abbr: 'TOR', logo: `${TEAM_LOGO_BASE}/TORB.png` },
  WSH: { name: 'Nationals', fullName: 'Washington Nationals', abbr: 'WSH', logo: `${TEAM_LOGO_BASE}/WSHN.png` },
  // Aliases for alternative abbreviations used by various APIs
  AZ:  { name: 'Diamondbacks', fullName: 'Arizona Diamondbacks', abbr: 'ARI', logo: `${TEAM_LOGO_BASE}/ARID.png` },
  CHW: { name: 'White Sox', fullName: 'Chicago White Sox', abbr: 'CWS', logo: `${TEAM_LOGO_BASE}/CHWW.png` },
  KCR: { name: 'Royals', fullName: 'Kansas City Royals', abbr: 'KC', logo: `${TEAM_LOGO_BASE}/KCR.png` },
  KAN: { name: 'Royals', fullName: 'Kansas City Royals', abbr: 'KC', logo: `${TEAM_LOGO_BASE}/KCR.png` },
  LAL: { name: 'Angels', fullName: 'Los Angeles Angels', abbr: 'LAA', logo: `${TEAM_LOGO_BASE}/LAAA.png` },
  LOS: { name: 'Dodgers', fullName: 'Los Angeles Dodgers', abbr: 'LAD', logo: `${TEAM_LOGO_BASE}/LADD.png` },
  SDP: { name: 'Padres', fullName: 'San Diego Padres', abbr: 'SD', logo: `${TEAM_LOGO_BASE}/SDP.png` },
  SFG: { name: 'Giants', fullName: 'San Francisco Giants', abbr: 'SF', logo: `${TEAM_LOGO_BASE}/SFG.png` },
  TBR: { name: 'Rays', fullName: 'Tampa Bay Rays', abbr: 'TB', logo: `${TEAM_LOGO_BASE}/TBR.png` },
  TAM: { name: 'Rays', fullName: 'Tampa Bay Rays', abbr: 'TB', logo: `${TEAM_LOGO_BASE}/TBR.png` },
  WAS: { name: 'Nationals', fullName: 'Washington Nationals', abbr: 'WSH', logo: `${TEAM_LOGO_BASE}/WSHN.png` },
  CWSW: { name: 'White Sox', fullName: 'Chicago White Sox', abbr: 'CWS', logo: `${TEAM_LOGO_BASE}/CHWW.png` },
};

export function getMLBTeamInfo(abbr: string): TeamInfo {
  return mlbTeams[abbr.toUpperCase()] || {
    name: abbr,
    fullName: abbr,
    abbr: abbr,
    logo: '',
  };
}

export const MLB_TEAM_NAME_TO_ABBR: Record<string, string> = {
  'Arizona Diamondbacks': 'ARI',
  'Diamondbacks': 'ARI',
  'Atlanta Braves': 'ATL',
  'Braves': 'ATL',
  'Baltimore Orioles': 'BAL',
  'Orioles': 'BAL',
  'Boston Red Sox': 'BOS',
  'Red Sox': 'BOS',
  'Chicago Cubs': 'CHC',
  'Cubs': 'CHC',
  'Chicago White Sox': 'CWS',
  'White Sox': 'CWS',
  'Cincinnati Reds': 'CIN',
  'Reds': 'CIN',
  'Cleveland Guardians': 'CLE',
  'Guardians': 'CLE',
  'Colorado Rockies': 'COL',
  'Rockies': 'COL',
  'Detroit Tigers': 'DET',
  'Tigers': 'DET',
  'Houston Astros': 'HOU',
  'Astros': 'HOU',
  'Kansas City Royals': 'KC',
  'Royals': 'KC',
  'Los Angeles Angels': 'LAA',
  'Angels': 'LAA',
  'Los Angeles Dodgers': 'LAD',
  'Dodgers': 'LAD',
  'Miami Marlins': 'MIA',
  'Marlins': 'MIA',
  'Milwaukee Brewers': 'MIL',
  'Brewers': 'MIL',
  'Minnesota Twins': 'MIN',
  'Twins': 'MIN',
  'New York Mets': 'NYM',
  'Mets': 'NYM',
  'New York Yankees': 'NYY',
  'Yankees': 'NYY',
  'Oakland Athletics': 'OAK',
  'Athletics': 'OAK',
  'Philadelphia Phillies': 'PHI',
  'Phillies': 'PHI',
  'Pittsburgh Pirates': 'PIT',
  'Pirates': 'PIT',
  'San Diego Padres': 'SD',
  'Padres': 'SD',
  'Seattle Mariners': 'SEA',
  'Mariners': 'SEA',
  'San Francisco Giants': 'SF',
  'Giants': 'SF',
  'St. Louis Cardinals': 'STL',
  'Cardinals': 'STL',
  'Tampa Bay Rays': 'TB',
  'Rays': 'TB',
  'Texas Rangers': 'TEX',
  'Rangers': 'TEX',
  'Toronto Blue Jays': 'TOR',
  'Blue Jays': 'TOR',
  'Washington Nationals': 'WSH',
  'Nationals': 'WSH',
};
